import type { ExportColumn } from '@/components/ui'
import type { CustomerDemandRow, InventoryRow, OrderHistoryLine } from '../api/types'

/**
 * CSV export columns for Uviva Inventory. Stable keys — user templates
 * in localStorage reference them. NEVER rename.
 */
export const INVENTORY_COLUMNS: readonly ExportColumn<InventoryRow>[] = [
  { key: 'product_code', header: 'Product Code', value: (r) => r.product_code },
  { key: 'product_name', header: 'Product', value: (r) => r.product_name },
  { key: 'lot_serial', header: 'Lot / Serial', value: (r) => r.lot_serial ?? '' },
  { key: 'on_hand', header: 'On Hand', value: (r) => r.on_hand },
  { key: 'reserved', header: 'Reserved', value: (r) => r.reserved },
  { key: 'available', header: 'Available', value: (r) => r.available },
  { key: 'uom', header: 'UoM', value: (r) => r.uom },
  { key: 'sell_by', header: 'Sell By', value: (r) => r.sell_by ?? '' },
  { key: 'location', header: 'Location', value: (r) => r.location },
] as const

/**
 * CSV export columns for Uviva customer demand (Operations page tabs and
 * the Reports "Customer Demand" tab). `line_type` is included so a
 * combined commercial+sample export can still be filtered in a
 * spreadsheet. Stable keys — NEVER rename.
 */
export const CUSTOMER_DEMAND_COLUMNS: readonly ExportColumn<CustomerDemandRow>[] = [
  { key: 'product_code', header: 'Product Code', value: (r) => r.product_code },
  { key: 'product_name', header: 'Product', value: (r) => r.product_name },
  { key: 'line_type', header: 'Type', value: (r) => r.line_type },
  { key: 'customer_name', header: 'Customer', value: (r) => r.customer_name },
  { key: 'so_name', header: 'SO #', value: (r) => r.so_name },
  { key: 'qty_ordered', header: 'Qty Ordered', value: (r) => r.qty_ordered },
  { key: 'qty_delivered', header: 'Qty Delivered', value: (r) => r.qty_delivered },
  { key: 'delivery_date', header: 'Delivery Date', value: (r) => r.delivery_date ?? '' },
  { key: 'status', header: 'Status', value: (r) => r.status },
] as const

/**
 * CSV export columns for Uviva order history (Reports page). Mirrors
 * the fields already flattened onto `OrderHistoryLine`. Stable keys —
 * NEVER rename.
 */
export const ORDER_HISTORY_COLUMNS: readonly ExportColumn<OrderHistoryLine>[] = [
  { key: 'po_ref', header: 'PO Ref', value: (r) => r.po_ref },
  { key: 'date_order', header: 'Order Date', value: (r) => r.date_order ?? '' },
  { key: 'status', header: 'Status', value: (r) => r.status },
  { key: 'product_code', header: 'Product Code', value: (r) => r.product_code },
  { key: 'product_name', header: 'Product', value: (r) => r.product_name },
  { key: 'qty_ordered', header: 'Qty Ordered', value: (r) => r.qty_ordered },
  { key: 'qty_received', header: 'Qty Received', value: (r) => r.qty_received },
  { key: 'uom', header: 'UOM', value: (r) => r.uom },
] as const
